import CustomStore from 'devextreme/data/custom_store';
import React from 'react'
import { getAllAppointments } from '../services/appointment.service';
import { Card } from 'react-bootstrap';
import { HasPermission } from 'Layout/Permissions/permissionsCache';
import DataGrid, { Column, Pager, Paging, Scrolling, SearchPanel, Summary, TotalItem } from 'devextreme-react/cjs/data-grid';
import ActionButton from './ActionButton';
import { formatDateToIST } from 'helpers/dateFormat';

const AppointmentList = () => {

    const dataSource = new CustomStore({
        key: 'id',
        load: async (loadOptions) => {
            try {
                const { searchValue, } = loadOptions;
                const parameterList = new URLSearchParams();
                const search = JSON.parse(JSON.stringify(loadOptions));
                for (const [key, value] of Object.entries(search)) {
                    parameterList.append(key, JSON.stringify(value));
                }

                if (searchValue) {
                    parameterList.append("search", searchValue);
                }
                const response = await getAllAppointments(parameterList);
                return response
            } catch (error) {
                console.error("Data loading error:", error);
                return { data: [], totalCount: 0 };
            }
        }
    });
    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Card>
                        <Card.Header className='d-flex justify-content-between align-items-center'>
                            <h5 className='m-0'>Appointment List</h5>
                        </Card.Header>
                        <Card.Body className="pt-0">
                            {/* {HasPermission('SalesEntry.Write') && */}
                            <DataGrid
                                dataSource={dataSource}
                                remoteOperations={{ groupPaging: true }}
                                showRowLines={true}
                                keyExpr="id"
                                columnAutoWidth={true}
                                showBorders={true}
                                onContentReady={(e) => {
                                    const hasData = e.component.totalCount() > 0;
                                    e.component.option("pager.visible", hasData);
                                    e.component.option("paging.visible", hasData);
                                }}
                                onCellPrepared={(e) => {
                                    if (['data', 'header'].includes(e.rowType)) {
                                        e.cellElement.style.textAlign = 'center';
                                    }
                                }}

                            >
                                <Scrolling
                                    mode='standard'
                                    useNative={true}
                                    scrollByContent={true}
                                    scrollByThumb={true}
                                />

                                <Pager
                                    showPageSizeSelector={true}
                                    allowedPageSizes={[10, 25, 50, 100]}
                                    showNavigationButtons={true}
                                    displayMode="full"
                                    showInfo={true}
                                />
                                <Summary>
                                    <TotalItem
                                    />
                                </Summary>
                                <Paging defaultPageSize={10} />
                                <SearchPanel visible width={240} placeholder="Search..." />
                                <Column
                                    caption="Action"
                                    width="100px"
                                    allowFiltering={false}
                                    cssClass="text-center"
                                    cellRender={({ data }) => (
                                        <ActionButton selectedId={data.id} />
                                    )}
                                />
                                <Column
                                    dataField="appointmentArn"
                                    caption="Appointment No."
                                    width={"180px"}
                                />

                                <Column
                                    dataField="guestName"
                                    caption="Guest Name"
                                    width={"200px"}
                                />

                                <Column
                                    dataField="guestMobile"
                                    caption="Guest Mobile No."
                                    width={"150px"}
                                />

                                <Column
                                    dataField="guestEmail"
                                    caption="Guest Email"
                                    width={"250px"}
                                />

                                <Column
                                    dataField="channel"
                                    caption="Channel"
                                    width={"120px"}
                                />

                                <Column
                                    dataField="appointmentType"
                                    caption="Appointment Type"
                                    width={"220px"}
                                />

                                <Column
                                    dataField="slotDate"
                                    caption="Slot Date"
                                    width={"240px"}
                                    allowFiltering={false}
                                    calculateDisplayValue={(rowData) => formatDateToIST(rowData.slotDate)}
                                />

                                <Column
                                    dataField="status"
                                    caption="Status"
                                    width={"120px"}
                                />

                                <Column
                                    dataField="eventType"
                                    caption="Event Type"
                                    width={"140px"}
                                />

                                {/* <Column
                                    dataField="updatedOnUtc"
                                    caption="Updated On"
                                    dataType="datetime"
                                    allowFiltering={false}
                                    calculateDisplayValue={(rowData) =>
                                        formatDateToIST(rowData.updatedOnUtc)
                                    }
                                    width={"220px"}
                                /> */}
                            </DataGrid>
                            {/* } */}
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </React.Fragment >
    )
}

export default AppointmentList
